// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formgroup-label[data-v-6fd990c8]{display:flex;flex-direction:column;min-height:4.8rem;justify-items:center;justify-content:center;padding-top:1.3rem;padding-bottom:1.3rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
